<template>
  <div class="purchaseOrder">
    <header-com>
      <ul class="navWrap f32 grey6">
        <li v-for="(item,index) in tabArr"
            :key="index"
            :class="{'active':tabActiveIndex === index}"
            @click="tabActiveIndex = index">{{item.name}}</li>
      </ul>
    </header-com>

    <!--订单列表-->
    <van-list v-model="myOrder.isLoading"
              v-show="tabActiveIndex === 0"
              :finished="myOrder.isFinished"
              finished-text=" "
              :offset="100"
              :immediate-check="false"
              @load="getMyOrderList"
              v-if="myOrder.list.length>0">
      <!--拥有列表-->
      <ul class="list">
        <li v-for="(item, index) in myOrder.list"
            :key="index">
          <order-item-com :item="item"
                          :stateName="stateObj[item.state]">
            <!--倒计时-->
            <div class="l countDownWrap"
                 v-if="item.state === 10"
                 slot="countDown">
              <span class="">剩余</span>
              <count-down :endTime="item.expireTime"
                          @timeEnd="item.state = 92"></count-down>
            </div>

            <!--待付款-->
            <div slot="btnGroup"
                 v-if="item.state === 10">
              <!--<div slot="btnGroup" >-->
              <div class="button"
                   @click="cancelOrder(item)">取消订单</div>
              <div class="button toPay"
                   @click="toPay(item)">立即支付</div>
            </div>
            <!--待收货-->
            <div slot="btnGroup"
                 v-else-if="item.state === 30">
              <div class="button"
                   @click="preBuyout(item,index)"
                   v-if="item.orderType != orderTypeObj.directBuy">买断</div>
              <div class="button"
                   @click="preChangeBag(item,index)"
                   v-if="item.orderType != orderTypeObj.directBuy">换背</div>
              <div class="button"
                   @click="showWuLiuPopup(item,index)">查看物流</div>
              <div class="button"
                   @click="preReceive(item)"
                   v-if="item.orderType == orderTypeObj.directBuy">确认收货</div>
            </div>

            <!--已收货 换背的订单 -->
            <div slot="btnGroup"
                 v-else-if="item.state === 40 && item.orderType != orderTypeObj.directBuy">
              <div class="button"
                   @click="showBuyoutPopup(item,index)">买断</div>
              <div class="button"
                   @click="returnBack(item,index)">立即退回</div>
              <!--<div class="button"
					 @click="$router.push({name:'sendBack',query:{from:'3',orderCode:item.orderCode}})">
				  立即退回</div>-->
              <div class="button"
                   @click="checkChangeBagService(item,index)">换背</div>
            </div>

          </order-item-com>
        </li>
      </ul>
    </van-list>

    <!--我背过的列表-->
    <van-list v-model="pastOrder.isLoading"
              :finished="pastOrder.isFinished"
              v-show="tabActiveIndex === 1"
              finished-text=" "
              :offset="100"
              :immediate-check="false"
              @load="getPastOrderList"
              v-if="pastOrder.list.length>0">
      <!--背过列表-->
      <ul>
        <li v-for="(item, index) in pastOrder.list"
            :key="index">
          <backed-com :item="item"></backed-com>
        </li>
      </ul>
    </van-list>

    <no-data v-if="isShowNoData"></no-data>

    <!--买断弹窗-->
    <van-popup v-model="isShowBuyoutPopup">
      <div class="buyoutPopup">
        <h2 class="f40 bold t_center">我要买断</h2>
        <ul class="content f28 grey6">
          <li><i>*</i> 买断后，即彻底买下，不再参与换背服务</li>
          <li><i>*</i> 服务期内，可以继续利用剩余换背次数购买 </li>
        </ul>
        <div class="btnGroup">
          <button class="cancel"
                  @click="isShowBuyoutPopup=false">取消</button>
          <button class="primary"
                  @click="confirmBuyOut()">确认</button>
        </div>
      </div>
    </van-popup>

    <!--为收货买断-->
    <van-popup v-model="reciveFlag"
               v-if="reciveFlag">
      <div class="buyoutPopup">
        <div class="info"
             v-if="buyoutItem.orderItem">
          <img :src="buyoutItem.orderItem.productPic | formatImgUrl(160,160,true)"
               align="middle"
               alt="" />
          <p>{{buyoutItem.orderItem.productBrand}}</p>
          <p>{{buyoutItem.orderItem.colorName}} {{buyoutItem.orderItem.productName}}</p>
          <div>
            <img src="/svg/flag.svg" />
            <span>¥</span>
            <time>{{buyoutItem.orderItem.productPrice}}</time>
          </div>
        </div>
        <p class="tips">亲，需要先“确认收货”后才可以“买断”哦</p>
        <div class="btnGroup">
          <button class="cancel"
                  @click="reciveFlag=false">取消</button>
          <button class="primary"
                  @click="checkSure()">确认收货并买断</button>
        </div>
      </div>
    </van-popup>

    <!--换背-->
    <van-popup v-model="isShiftBuyoutPopup"
               v-if="isShiftBuyoutPopup">
      <div class="buyoutPopup">
        <div class="info"
             v-if="buyoutItem.orderItem">
          <img :src="buyoutItem.orderItem.productPic | formatImgUrl(160,160,true)"
               align="middle"
               alt="" />
          <p>{{buyoutItem.orderItem.productBrand}}</p>
          <p>{{buyoutItem.orderItem.colorName}} {{buyoutItem.orderItem.productName}}</p>
          <div>
            <img src="/svg/flag.svg" />
            <span>¥</span>
            <time>{{buyoutItem.orderItem.productPrice}}</time>
          </div>
        </div>
        <p class="tips">亲，需要先“确认收货”后才可以“换背”哦</p>
        <div class="btnGroup">
          <button class="cancel"
                  @click="isShiftBuyoutPopup=false">取消</button>
          <button class="primary"
                  @click="checkShiftBag">确认收货</button>
        </div>
      </div>
    </van-popup>

    <!--物流弹窗-->
    <!--<wu-liu-popup ref="wuLiuPopup" ></wu-liu-popup>-->
    <van-popup v-model="transport"
               v-if="transport">
      <div class="buyoutPopup">
        <div class="info"
             v-if="buyoutItem.orderItem">
          <img :src="buyoutItem.orderItem.productPic | formatImgUrl(160,160,true)"
               align="middle"
               alt="" />
          <p>{{buyoutItem.orderItem.productBrand}}</p>
          <p>{{buyoutItem.orderItem.colorName}} {{buyoutItem.orderItem.productName}}</p>
          <div>
            <img src="/svg/flag.svg"
                 v-if="buyoutItem.orderType !== orderTypeObj.directBuy" />
            <span>¥</span>
            <time>{{buyoutItem.orderItem.productPrice}}</time>
          </div>
        </div>
        <p class="trans_name">物流详情</p>
        <p class="adress">收货地址: {{reciveAddress}}</p>
        <ul class="routine"
            v-if="routeObj">
          <li v-for="ite in routeObj.route">
            <div class="left">
              <p>{{ite.acceptTime}}</p>
            </div>
            <div class="right">
              <p>{{ite.remark}}</p>
            </div>
          </li>
        </ul>
        <div class="space"></div>
      </div>
    </van-popup>

    <!--支付弹窗-->
    <pay-type-popup ref="payTypePopup"
                    @selectPayType="confirmPay"></pay-type-popup>

    <!--换背校验弹窗-->
    <van-popup v-model="isCheckChangeBagServicePopup">
      <div class="buyoutPopup">
        <h2 class="f40 bold t_center">此包已被买断，不可换背！</h2>
        <ul class="content f28 grey6">
          <li>可能原因：</li>
          <li><i>*</i> 换背服务卡已到期</li>
          <li><i>*</i> 换背服务中断，中断日期前在背包包自动买断 </li>
          <li class="f24 grey9"> 如有任何疑问，可咨询陈真小助手。</li>
        </ul>
        <div class="btnGroup">
          <button class="cancel"
                  @click="isCheckChangeBagServicePopup=false">取消</button>
          <button class="primary "
                  @click="confirmBuyOut">确认</button>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import backedCom from './backedCom'
import orderApi from '@api/order'
import addressApi from '@api/address'
import payApi from '@api/pay'
import publicObj from '@utils/public'
import payObj from '@utils/pay'
import NoData from "../../../components/noData";
import { mapState } from 'vuex'
export default {
  name: "purchaseOrder",
  components: { NoData, backedCom },
  data() {
    return {
      transport: false,
      routeObj: '',
      reciveAddress: '',
      tabActiveIndex: Number(this.$route.query.tabActiveIndex) || 0,
      tabArr: [
        { name: '我的订单', id: 0 },
        { name: '换背订单', id: 1 },
      ],
      //我拥有的
      myOrder: {
        list: [],
        isLoading: false,
        isFinished: false,
        pageConfig: {
          pageNum: 1,
          pageSize: 10,
          total: 0
        }
      },
      prePayItem: {},
      //我背过得
      pastOrder: {
        list: [],
        isLoading: false,
        isFinished: false,
        pageConfig: {
          pageNum: 1,
          pageSize: 10,
          total: 0
        }
      },
      isShowBuyoutPopup: false,
      reciveFlag: false,
      isShiftBuyoutPopup: false,
      buyoutItem: {},
      buyoutIndex: '',
      //91:'用户取消' 92:'平台取消' 93:'客服取消' 94:'erp创建订单失败取消',
      stateObj: {
        10: '待付款',
        20: '待发货',
        30: '待收货',
        40: '已收货',
        91: '已取消',
        92: '已取消',
        93: '已取消',
        94: '已取消',
      },
      isCheckChangeBagServicePopup: false
    }
  },
  watch: {},
  computed: {
    ...mapState({
      orderTypeObj: 'orderTypeObj'
    }),
    isShowNoData() {
      if ((this.tabActiveIndex === 0 && this.myOrder.list.length === 0)
        || (this.tabActiveIndex === 1 && this.pastOrder.list.length === 0)) {
        return true
      } else {
        return false
      }
    }
  },
  created() {
    this.getPastOrderList();
    this.getMyOrderList()

  },
  mounted() {

  },
  methods: {
    // changeTabs(index){
    //   this.tabActiveIndex = index;
    // },

    // 获取我拥有的订单列表
    getMyOrderList() {
      orderApi.getMyOrderList({
        ...this.myOrder.pageConfig,
      }).then(res => {
        let list = [...this.myOrder.list];
        this.myOrder.isLoading = false;
        this.myOrder.list = list.concat(res.result);
        this.myOrder.pageConfig.total = res.total;
        if (this.myOrder.list.length >= this.myOrder.pageConfig.total) {
          this.myOrder.isFinished = true;
        } else {
          this.myOrder.pageConfig.pageNum++;
        }
      }).catch(res => {
        // this.isLoading = false;
        //console.log(res)
      })
    },
    resetMyOrderList() {
      this.myOrder.pageConfig.pageNum = 1;
      this.myOrder.list = [];
      this.myOrder.isLoading = true;
      this.myOrder.isFinished = false;
      this.getMyOrderList()
    },
    // 获取我拥有的订单列表
    getPastOrderList() {
      orderApi.getPastOrderList({
        ...this.pastOrder.pageConfig,
      }).then(res => {
        let list = [...this.pastOrder.list];
        this.pastOrder.isLoading = false;
        this.pastOrder.list = list.concat(res.result);
        this.pastOrder.pageConfig.total = res.total;
        if (this.pastOrder.list.length >= this.pastOrder.pageConfig.total) {
          this.pastOrder.isFinished = true;
        } else {
          this.pastOrder.pageConfig.pageNum++;
        }
      }).catch(res => {
        // this.isLoading = false;
        //console.log(res)
      })
    },
    resetPastOrderList() {
      this.pastOrder.pageConfig.pageNum = 1;
      this.pastOrder.list = [];
      this.pastOrder.isLoading = true;
      this.pastOrder.isFinished = false;
      this.getPastOrderList()
    },
    //取消订单
    cancelOrder(item) {
      this.$dialog.confirm({
        title: '提示',
        message: '是否取消订单'
      }).then(() => {
        orderApi.cancelOrder({
          orderCode: item.orderCode
        }).then(res => {
          //诸葛：取消订单
          let proDetail = item.orderItem,
            zhugeName = item.orderType != this.orderTypeObj.directBuy ? "换背订单-取消订单" : "直购订单-取消订单"
          zhuge.track(zhugeName, {
            "商品名称": proDetail.productName,
            "品牌": proDetail.productBrand,
            "价格": proDetail.productPrice,
            "订单id": item.orderCode,
            "商品等级": proDetail.levelName
          });
          this.resetMyOrderList()
          this.resetPastOrderList()
        })
      }).catch(() => { });
    },
    //立即支付
    toPay(item) {
      //诸葛：直购订单-立即支付
      let proDetail = item.orderItem,
        zhugeName = item.orderType != this.orderTypeObj.directBuy ? "换背订单-立即支付" : "直购订单-立即支付"
      zhuge.track(zhugeName, {
        "商品名称": proDetail.productName,
        "品牌": proDetail.productBrand,
        "价格": proDetail.productPrice,
        "订单id": item.orderCode,
        "商品等级": proDetail.levelName
      });
      this.prePayItem = { ...item };
      if (publicObj.isWeiXin()) {
        //微信内支付
        this.confirmPay()
      } else {
        //微信外支付 展示弹窗选择
        this.$refs['payTypePopup'].show()
      }
    },
    // 确认支付
    confirmPay(payType) {
      //根据订单号获取支付参数
      const payParams = payObj.getPayParams({
        payType: payType,
        orderCode: this.prePayItem.orderCode,
        backType: payObj.backTypeObj.order,
      });

      payObj.isWeiXinApp(payParams.clientType, {
        orderCode: this.prePayItem.orderCode,
        remainTime: this.prePayItem.expireTime,
      }).then(message => {
        // 立即支付
        payApi.payByOrderCode({
          orderCode: this.prePayItem.orderCode,
          ...payParams
        }).then(res => {
          payObj.confirmPay(payParams.clientType, res)
        })
      })


    },
    // 查看物流
    showWuLiuPopup(item, index) {
      this.transport = true;
      this.buyoutItem = item;
      this.buyoutIndex = index;

      orderApi.getOrderDetail({
        orderCode: item.orderCode
      }).then(res => {
        if (res) {
          this.reciveAddress = res.receiverProvince + res.receiverCity + res.receiverCounty + res.receiverDetailAddress;
          this.getRouteInfo(res.expressSn)
        }
        //        this.$refs['wuLiuPopup'].show(res)
      });
    },
    getRouteInfo(orderCode) {
      addressApi.getRoutine(orderCode).then(res => {
        this.routeObj = res.body.routeResponse;
      })
    },
    //确认收货提示框
    preReceive(item) {
      this.$dialog.confirm({
        title: '提示',
        message: '是否要确认收货'
      }).then(() => {
        this.confirmReceive(item)
      }).catch(() => { });
    },
    //确认收货
    confirmReceive(item) {
      return new Promise(resolve => {
        //诸葛：直购订单-确认收货
        let proDetail = item.orderItem
        zhuge.track("直购订单-确认收货", {
          "商品名称": proDetail.productName,
          "品牌": proDetail.productBrand,
          "价格": proDetail.productPrice,
          "订单id": item.orderCode,
          "商品等级": proDetail.levelName
        });
        orderApi.confirmReceive({
          orderCode: item.orderCode
        }).then(() => {
          item.state = 40;
          resolve()
        })
      })
    },

    //待收货的买断
    checkSure() {
      this.confirmReceive(this.buyoutItem).then(() => {
        this.confirmBuyOut()
      })
    },
    // 待收货状态下点击买断
    preBuyout(item, index) {
      this.reciveFlag = true;
      this.buyoutItem = item;
      this.buyoutIndex = index;
    },

    //确认收货换背
    checkShiftBag() {
      this.confirmReceive(this.buyoutItem).then(() => {
        this.$router.push({ name: 'proList', query: { "lable": 1 } })
      })
    },

    // 待收货状态下点击换背
    preChangeBag(item, index) {
      //诸葛：换背订单-换背
      let proDetail = item.orderItem
      zhuge.track("换背订单-换背（待收货）", {
        "商品名称": proDetail.productName,
        "品牌": proDetail.productBrand,
        "价格": proDetail.productPrice,
        "订单id": item.orderCode,
        "商品等级": proDetail.levelName
      });
      this.isShiftBuyoutPopup = true;
      this.buyoutItem = item;
      this.buyoutIndex = index;
    },
    //展示买断弹窗
    showBuyoutPopup(item, index) {
      this.buyoutItem = item;
      orderApi.checkChangeBagService(item.orderItem.id).then(res => {
        if (res) {
          this.isShowBuyoutPopup = true;
          this.buyoutIndex = index
        }
      }).catch(() => {
        this.$toast('服务到期，已自动买断,存入换背选项中')
        this.confirmBuyOut()
      })


    },
    //立即返回
    returnBack(item, index) {
      this.buyoutItem = item;
      orderApi.checkChangeBagService(item.orderItem.id).then(res => {
        if (res) {
          //诸葛：换背订单-立即退回
          let proDetail = item.orderItem
          zhuge.track("换背订单-立即退回", {
            "商品名称": proDetail.productName,
            "品牌": proDetail.productBrand,
            "价格": proDetail.productPrice,
            "订单id": item.orderCode,
            "商品等级": proDetail.levelName
          });
          this.$router.push({ name: 'sendBack', query: { from: '3', orderCode: item.orderCode } })
        }
      }).catch(() => {
        this.$toast('服务到期，已自动买断,存入换背选项中')
        this.confirmBuyOut()
      })
    },
    //确认买断
    confirmBuyOut() {
      orderApi.confirmBuyOut(this.buyoutItem.orderItem.id).then(res => {

        //诸葛：换背订单-买断
        let proDetail = this.buyoutItem.orderItem,
          zhugeName = this.buyoutItem.state == 30 ? "换背订单-买断（待收货）" : "换背订单-买断（已收货）"
        zhuge.track(zhugeName, {
          "商品名称": proDetail.productName,
          "品牌": proDetail.productBrand,
          "价格": proDetail.productPrice,
          "订单id": this.buyoutItem.orderCode,
          "商品等级": proDetail.levelName
        });

        this.$toast('买断成功');
        this.isShowBuyoutPopup = false;
        this.reciveFlag = false;
        this.isCheckChangeBagServicePopup = false;
        this.myOrder.list.splice(this.buyoutIndex, 1);
        //重新获取拥有的订单列表
        this.pastOrder.list = [];
        this.pastOrder.pageConfig.pageNum = 1;
        this.pastOrder.isLoading = true;
        this.pastOrder.isFinished = false;
        this.getPastOrderList()
      })
    },
    //校验换背状态
    checkChangeBagService(item, index) {
      this.buyoutItem = item;
      orderApi.checkChangeBagService(item.orderItem.id).then(res => {
        if (res) {
          //诸葛：换背订单-换背
          let proDetail = item.orderItem
          zhuge.track("换背订单-换背（已收货）", {
            "商品名称": proDetail.productName,
            "品牌": proDetail.productBrand,
            "价格": proDetail.productPrice,
            "订单id": item.orderCode,
            "商品等级": proDetail.levelName
          });
          this.$router.push({ name: 'proList', query: { "lable": 1 } })
        } else {
          this.isCheckChangeBagServicePopup = true;
        }
      }).catch(() => {
        this.$toast('服务到期，已自动买断,存入换背选项中')
        this.confirmBuyOut()
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.purchaseOrder {
  .van-popup {
    max-height: 60%;
    overflow-y: scroll;
  }
  padding: 120px 40px 0;
  .navWrap {
    display: flex;
    justify-content: center;
    position: relative;
    &:after {
      content: "";
      width: 2px;
      height: 32px;
      background: $base-grey;
      position: absolute;
      left: 50%;
      top: 16px;
    }
    li {
      padding: 0 64px;
      position: relative;
    }
    .active {
      color: $primary-color;
      &:after {
        @include navActive;
        left: 50%;
        top: 56px;
      }
    }
  }

  .list li .toPay {
    color: $primary-color;
    font-size: 24px;
    border: 2px solid $base-grey;
  }
  li {
    .countDownWrap {
      color: $primary-color;
      font-size: 26px;
      line-height: 56px;
      /*font-weight: bold;*/
      letter-spacing: 1px;
      padding-left: 35px;
      background: url("/images/order/count_down.png") no-repeat left 14px;
      background-size: 26px;
      span {
        display: inline-block;
        line-height: 32px;
        /*margin-left: 8px;*/
        vertical-align: middle;
      }
    }
  }
  .buyoutPopup {
    width: 678px;
    /*height: 548px;*/
    background: $white-color;
    box-sizing: border-box;
    h2 {
      padding: 40px 0;
      border-bottom: $dashed-border;
    }
    .trans_name {
      font-size: 28px;
      margin: 76px 0 36px 42px;
    }
    .adress {
      font-size: 20px;
      margin: 0 0 42px 42px;
    }
    .routine {
      li {
        display: flex;
        div {
          padding: 0 0 42px 42px;
          p {
            margin-top: 12px;
            color: #fd946c;
            line-height: 30px;
          }
        }
        .left {
          border-right: 1px solid $light-grey;
          width: 82px;
          text-align: right;
          padding-right: 42px;
        }
        .right {
          padding-right: 42px;
        }
      }
    }
    .space {
      height: 56px;
      margin-top: -6px;
      background: white;
      position: relative;
      z-index: 66;
    }
    .content {
      padding: 36px 20px 54px;
      line-height: 64px;
      i {
        font-size: 32px;
      }
    }
    .tips {
      text-align: center;
      font-size: 24px;
      color: $light-grey;
      margin: 65px 0 32px 0;
    }
    .info {
      text-align: center;
      p {
        font-size: 28px;
        margin-bottom: 16px;
      }
      div {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 25px;
        img {
          height: 48px;
          width: 32px;
        }
        span {
          font-size: 12px;
          margin: 0 12px 0 18px;
        }
        time {
          font-size: 24px;
          font-weight: 500;
        }
      }
    }
    .btnGroup {
      display: flex;
      justify-content: space-between;

      button {
        width: 50%;
        text-align: center;
        border-radius: initial;
      }
    }
  }
}
</style>
